module.exports = __webpack_public_path__ + "img/punda-detail.dc503489.webp";